import {
  UserAttribute,
  UserAttributeCatalog,
  UserAttributeCatalogKey,
} from '@hc-frontend/services';
import { assoc, reduce } from 'ramda';

export function userAttributesMapper(userAttributes: UserAttribute[]) {
  const userAttributesMap: Partial<{
    [key in UserAttributeCatalogKey]: UserAttributeCatalog[key];
  }> = {
    ...reduce(
      (acc, curr) => assoc(curr.name, curr.value, acc),
      {},
      userAttributes,
    ),
  };
  return userAttributesMap;
}
